<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.liste.baslikYayin")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                text-color="gray">
                    <el-radio-button label="1">
                        <i class="mdi mdi-cards-outline mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                        <transition
                                name="slide-fade"><label v-if="selectIcon==='1'">Yayındaki Ürünler</label>
                        </transition>
                    </el-radio-button>
                    <el-radio-button label="0">
                        <i class="mdi mdi-cards-outline mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                        <transition
                                name="slide-fade"><label v-if="selectIcon==='0'">Taslak Ürünler</label>
                        </transition>
                    </el-radio-button>
                </el-radio-group>
            </el-col>
            <el-table
                    :data="urunlerList"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="urunKodu"
                        label="Ürün Kodu"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="kategoriAdi"
                        label="Kategori"
                        width="auto">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="urunAdi"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="malzemeAdi"
                        label="Malzeme"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='scope.row.olusturan' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    style="color: #337ab7"
                                    type="text"
                                    icon="mdi mdi-account mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <!--<el-tooltip content='Düzenle'-->
                                    <!--:open-delay="500"-->
                                    <!--placement="bottom">-->
                            <!--<el-button-->
                                    <!--v-on:click="routeUrun('Ürün Düzenle',scope.row)"-->
                                    <!--type="text"-->
                                    <!--class="buttonEdit"-->
                                    <!--icon="el-icon-edit">-->
                            <!--</el-button>-->
                        <!--</el-tooltip>-->
                        <!--<el-tooltip :content='$t("src.views.apps.urun.liste.urunduzenle")'-->
                                    <!--:open-delay="500"-->
                                    <!--placement="bottom">-->
                            <!--<el-button-->
                                    <!--v-if="root || yetkiList.urunGuncelle"-->
                                    <!--v-on:click="routeUrun('Ürün Düzenle',scope.row)"-->
                                    <!--type="text"-->
                                    <!--class="buttonEdit"-->
                                    <!--icon="el-icon-edit">-->
                            <!--</el-button>-->
                        <!--</el-tooltip>-->
                        <!--<el-tooltip :content='$t("src.views.apps.haberler.liste.haberdetay")' :open-delay="500"-->
                                    <!--placement="bottom">-->
                            <!--<el-link target="_blank" class="margin-bottom-7" icon="mdi mdi-redo-variant mdi-24px"-->
                                     <!--:underline="false" :href="path+scope.row.link">-->
                            <!--</el-link>-->
                        <!--</el-tooltip>-->
                        <el-tooltip :content='$t("src.views.apps.urun.liste.urunkaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1'"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    class="buttonDel"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0'"
                                    @click="urunDurumDegis(scope.row,scope.$index,urunlerList,'1')"
                                    type="text"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content='PDF Oluştur' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    style="color: black"
                                    @click="urunKatalog(scope.row)"
                                    type="text"
                                    icon="mdi mdi-file mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.urun.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.urunKodu}}' {{$t('src.views.apps.urun.liste.uruntaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="urunDurumDegis(selection,selectionIndex,urunlerList,'0'), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import urunService from '../../../WSProvider/UrunService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstasMil = "";

    export default {
        name: "UrunListesi",
        data() {
            return {
                path: urunService.path,
                sizes: 10,
                page: 0,
                postPage: 0,
                total: null,
                urunlerList: [],
                deleteDialogVisible: false,
                selection: '',
                selectIcon: '1',
                radio: '1',
                selectionIndex: '',
                root: false,
                yetkiList: {
                    urunGuncelle: false,
                    urunDurumChange: false,
                },
            }
        },
        mounted() {
            this.urunCount();
            this.getUrunList();

        },
        methods: {
            urunKatalog(scope){
                var userDataEstasMil = JSON.parse(base64.decode(localStorage.getItem("userDataEstasMil")));
                window.open('https://estas.hakanbt.com.tr/katalog/estas-mil-cikti/index.php?UK=' + scope.urunKodu + '&KATALOG=0&TOKEN='+userDataEstasMil["token"], "_blank");

            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getUrunList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.urunCount();
                this.getUrunList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getUrunList();
            },
            urunCount() {
                urunService.urunCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            routeUrun(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.urunKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            getUrunList() {
                urunService.urunTumListesi(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.urunlerList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            urunDurumDegis(selection, index, list, durum) {
                urunService.urunDurumGuncelle(selection.urunKodu, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                list.splice(index, 1);
                                notification.Status("success", this, "Ürün taslağa taşındı.");
                                break;
                            case '1':
                                list.splice(index, 1);
                                notification.Status("success", this, "Ürün yayına alındı.");
                                break;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss">
    .el-table .info-row {
        background: rgba(125, 199, 225, 0.45);
    }

    .el-table .error-row {
        background: rgba(249, 0, 26, 0.08);
    }

    .el-table .success-row {
        background: rgba(3, 249, 0, 0.08);
    }

    .el-table .warning-row {
        background: rgba(245, 249, 0, 0.08);
    }
</style>
<style lang="scss" scoped>
    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: rotate(360deg);
    }

    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>